import { createFileRoute } from '@tanstack/react-router'
import { CaseViewPage } from '@/features/cases'

/**
 * Case detail. Deep-linkable: `/cases/<id>/view` opens the case directly without
 * going through a cases list (there isn't one yet).
 *
 * No `beforeLoad` guard on purpose — access is decided by the API, which gates
 * every `/cases` endpoint on the per-tenant `cases.enabled` flag and returns
 * `403`/`404` accordingly. Add a `requireAccess({ permission: … })` here once a
 * case permission exists in `lib/rbac`.
 */
export const Route = createFileRoute('/_auth/cases/$caseId/view')({
  component: CaseViewRoute,
})

function CaseViewRoute() {
  const { caseId } = Route.useParams()
  return <CaseViewPage caseId={caseId} />
}
